import storage from "../../../utils/store/storage";
import { SESSION_ID } from "../../../utils/store/storeVariables";

export function saveSessionId(sessionId?: string, rememberMe?: boolean) {
  storage.saveItem(SESSION_ID, rememberMe ?? false, sessionId);
}
